// src/services/restaurantApi.js
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

function getAuthHeaders() {
  const token = localStorage.getItem("access_token"); 
  if (!token) return {};
  return {
    Authorization: `Bearer ${token}`,
  };
}

/**
 * Carica i ristoranti dell'admin (endpoint /admin/restaurants)
 */
export async function fetchRestaurants() {
  const res = await axios.get(`${BASE_URL}/admin/restaurants`, {
    headers: getAuthHeaders(),
  });
  return res.data; // Array di RestaurantRead
}
